import { supabase } from './supabase';

/**
 * Log an action to the audit_logs table
 * @param {string} action - The action performed (created, updated, deleted)
 * @param {string} recordType - The type of record (job, property)
 * @param {string|null} recordId - The UUID of the record
 * @param {object} details - Additional details about the action
 */
export const logAudit = async (action, recordType, recordId, details = {}) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();

    if (!user) return; // Don't log if no user (shouldn't happen)

    await supabase.from('audit_logs').insert({
      action: `${recordType}.${action}`,
      user_id: user.id,
      user_email: user.email,
      record_type: recordType,
      record_id: recordId,
      details: {
        ...details,
        timestamp: new Date().toISOString(),
      },
    });
  } catch (error) {
    // Silently fail - don't break the app if logging fails
    console.error('Audit log failed:', error);
  }
};

// Convenience methods
export const logJobCreated = (jobId, details) => logAudit('created', 'job', jobId, details);
export const logJobUpdated = (jobId, details) => logAudit('updated', 'job', jobId, details);
export const logJobDeleted = (jobId, details) => logAudit('deleted', 'job', jobId, details);

export const logPropertyCreated = (propertyId, details) => logAudit('created', 'property', propertyId, details);
export const logPropertyUpdated = (propertyId, details) => logAudit('updated', 'property', propertyId, details);
export const logPropertyDeleted = (propertyId, details) => logAudit('deleted', 'property', propertyId, details);

export const logLogin = (userId, email) => logAudit('login', 'auth', userId, { email });
